// deno-lint-ignore-file ban-unused-ignore no-explicit-any no-empty-interface
///////////////////////////////////
// !!! DO NOT EDIT THIS FILE !!! //
///////////////////////////////////

import type { SlackAPIResponse } from "../response";
export type AdminWorkflowsCollaboratorsAddResponse = SlackAPIResponse & {
  error?: string;
  errors?: Error[];
  needed?: string;
  ok: boolean;
  provided?: string;
  response_metadata?: ResponseMetadata;
};

export interface Error {
  message?: string;
  user?: string;
  workflow?: string;
}

export interface ResponseMetadata {
  messages?: string[];
}
